import { render } from "./StoreTabKoovea.vue?vue&type=template&id=18597250&scoped=true&ts=true"
import script from "./StoreTabKoovea.vue?vue&type=script&lang=ts"
export * from "./StoreTabKoovea.vue?vue&type=script&lang=ts"

import "./StoreTabKoovea.vue?vue&type=style&index=0&id=18597250&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18597250"]])

export default __exports__